import { useState, useEffect } from 'react';
import InteractionButtons from './lead-journey/InteractionButtons';
import {useGetInteractions} from '../api/reminder/useGetInteractions.js';

export default function InteractionComponent({leadID, owner}) {
  const [showTable, setShowTable] = useState(false); // Controls whether the table is shown
  
  const {lastInteraction, allInteractions, refetch} = useGetInteractions({leadID: leadID})

  const handleInteractionAdd = () =>{
    refetch()
  }
  // Close the modal
  const closeModal = () => {
    setShowTable(false);
  };

  return (
    <div className="p-5 flexitems-start bg-white shadow-sm rounded-3xl w-1/2 mr-3 ml-5">
      <div className="flex justify-between items-start mt-3 w-full border-b border-gray-300 pb-2 mr-5">
          <div className='flex justify-between items-start'>
              <img src="/icons/handshake.svg" className='mt-1 size-7'/>
              <h1 className="font-semibold text-3xl mb-2 ml-2">Interactions</h1>
          </div>
          {owner && <InteractionButtons leadID={leadID} onInteractionAdd={handleInteractionAdd}/>}
      </div>

      <div className="flex justify-between items-start mt-3">
      {/* Display Last Reminder */}
      {lastInteraction ? (
        <div className="mb-4">
        <h2 className="text-lg font-small mb-2 text-gray-400">Recent Interaction:</h2>
        <p className="text-gray-700 font-light"> {lastInteraction.date_of_interaction}</p>
        <p className="text-gray-700 text-lg"><strong>{lastInteraction.notes}</strong></p>
        <p className="text-gray-700">{lastInteraction.contact_method}</p>
      </div>
      ) : (
        <p className="text-gray-500">No interactions available.</p>
      )}

      {/* View All Button */}
      <button
        onClick={() => setShowTable(true)}
        className="text-black underline hover:text-blue-800 focus:outline-none mr-2 font-bold text-sm"
      >
        View All
      </button>
      </div>

      {/* Modal to display the table of all interactions */}
      {showTable && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-[60]"
        onClick={closeModal}>
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 md:w-1/2 max-w-screen max-h-[80vh] overflow-auto"
          onClick={(e) => e.stopPropagation()}>
            <div className="overflow-x-auto mb-4">
              <table className="min-w-full bg-white border">
                <thead>
                  <tr className="bg-gray-100 border-none text-neutral-400">
                    <th className="py-2 px-4 text-start text-lg">ID</th>
                    <th className="py-2 px-4 text-start text-lg">Contact Method</th>
                    <th className="py-2 px-4 text-start text-lg">Date of Interaction</th>
                    <th className="py-2 px-4 text-start text-lg">Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {allInteractions.interactions.map((currinteraction) => (
                    <tr key={currinteraction.id} className="border-t">
                      <td className="py-2 px-4">{currinteraction.id}</td>
                      <td className="py-2 px-4">{currinteraction.contact_method}</td>
                      <td className="py-2 px-4">{currinteraction.date_of_interaction}</td>
                      <td className="py-2 px-4">{currinteraction.notes}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button
              onClick={closeModal}
              className="bg-yellow-300 text-black px-4 py-2 rounded hover:bg-yellow-400"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}